// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__rQGjG","tab":"Tabs_tab__X52T4","fileType":"Tabs_fileType__jzFJd","active":"Tabs_active__uGUKx","close":"Tabs_close__gcCGC","newTab":"Tabs_newTab__x33s0"};